(function() {
  // Only run in browser context
  if (typeof document === 'undefined') return;

  // Wait for DOM to be ready
  function ready(callback) {
    if (document.readyState !== 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  ready(function() {
    // Find the account deletion container
    const container = document.getElementById('shopify-account-deletion-container');
    if (!container) return;

    // Get customer and shop IDs from container data attributes
    const customerId = container.getAttribute('data-customer-id');
    const shopId = container.getAttribute('data-shop-id');

    if (!customerId || !shopId) {
      console.error('Missing customer ID or shop ID for account deletion');
      return;
    }

    // Add translations to window.theme
    window.theme = window.theme || {};
    window.theme.translations = window.theme.translations || {};
    window.theme.translations.deleteAccount = {
      button: "Delete account",
      cancelButton: "Cancel request",
      closeButton: "Close",
      cancelRequestButton: "Cancel request",
      modalTitle: "Are you sure?",
      cancelModalTitle: "Cancel Account Deletion?",
      immediateDeleteWarning: "After confirming, your account will be deleted immediately. All your data will be permanently deleted.",
      gracePeriodWarning: "After confirming, your account will be deleted in {{period}}. You can cancel this request anytime during this period. After this period, all your data will be permanently deleted.",
      cancelConfirmationText: "Are you sure you want to cancel your account deletion request? This action cannot be undone.",
      deletionScheduleText: "Your account is scheduled for deletion on {{date}}",
      successMessages: {
        requestCreated: "Account deletion request created successfully.",
        requestCanceled: "Account deletion request canceled successfully."
      },
      errorMessages: {
        requestCreateFailed: "There was an error processing your request. Please try again later.",
        requestCancelFailed: "There was an error cancelling your request. Please try again later.",
        noCustomer: "No authenticated customer found.",
        sessionTokenError: "Failed to retrieve session token.",
        shopIdError: "Shop ID not found in response",
        missingInfo: "Missing required information"
      },
      timePeriods: {
        daysAndHours: "{{days}} days and {{hours}} hours",
        daysOnly: "{{days}} days",
        hoursOnly: "{{hours}} hours",
        immediately: "immediately"
      }
    };

    // Add CSS
    const styles = `
      .account-delete-button-container {
        margin-top: 20px;
        margin-bottom: 20px;
      }

      /* Loading spinner styles */
      .subscription-check-loading {
        text-align: center;
        padding: 1rem 0;
      }

      .loading-spinner {
        border: 3px solid #f3f3f3;
        border-top: 3px solid #3498db;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        animation: spin 1s linear infinite;
        display: inline-block;
      }

      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }

      /* Modal styles */
      .modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: none;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        background-color: rgba(0, 0, 0, 0.5);
      }
      
      .modal-content {
        background-color: #ffffff;
        border-radius: 6px;
        max-width: 500px;
        width: 90%;
      }

      .modal-header {
        padding: 1.5rem;
        border-bottom: 1px solid #e5e7eb;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .modal-header h2 {
        margin: 0;
        font-size: 20px;
        font-weight: 600;
        color: #111827;
      }

      .close-button {
        background: none;
        border: none;
        font-size: 1.5rem;
        cursor: pointer;
        color: #111827;
        padding: 0;
      }

      .modal-description {
        padding: 1.5rem;
        margin: 0;
        color: #111827;
        font-size: 16px;
        line-height: 1.5;
      }
      
      .modal-actions {
        padding: 1.5rem;
        display: flex;
        justify-content: flex-start;
        gap: 0.75rem;
        border-top: 1px solid #e5e7eb;
      }

      /* Main buttons */
      .delete-button:not(.modal .delete-button) {
        background-color: transparent;
        border: 1px solid #dc2626;
        color: #dc2626;
        padding: 1.2rem 2rem;
        border-radius: 6px;
        font-weight: 500;
        font-size: 16px;
        cursor: pointer;
        transition: background-color 0.2s;
      }

      .cancel-request-button {
        background-color: #111827;
        border: none;
        color: #ffffff;
        padding: 1.2rem 2rem;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.2s;
        width: auto;
        display: inline-block;
      }

      .cancel-button:not(.modal .cancel-button) {
        background-color: #111827;
        border: none;
        color: #ffffff;
        padding: 1.2rem 2rem;
        border-radius: 6px;
        font-weight: 500;
        font-size: 16px;
        cursor: pointer;
        transition: background-color 0.2s;
      }

      /* Modal buttons */
      .modal .delete-button {
        background-color: #dc2626;
        border: none;
        color: #ffffff;
        padding: 1.2rem 2rem;
        border-radius: 6px;
        font-weight: 500;
        font-size: 16px;
        cursor: pointer;
        transition: background-color 0.2s;
      }

      .modal .cancel-button {
        background-color: transparent;
        border: 1px solid #111827;
        color: #111827;
        padding: 1.2rem 2rem;
        border-radius: 6px;
        font-weight: 500;
        font-size: 16px;
        cursor: pointer;
        transition: background-color 0.2s;
      }

      .pending-deletion-notice {
        text-align: center;
      }

      .deletion-message {
        font-size: 16px;
        margin: 0 0 1rem 0;
        color: #111827;
      }
    `;
    
    const styleElement = document.createElement('style');
    styleElement.textContent = styles;
    document.head.appendChild(styleElement);

    // Inject HTML
    container.innerHTML = `
      <div class="account-delete-button-container" id="delete-button-container" style="margin-top: 20px;">
        <!-- Loading state -->
        <div id="subscription-loading" style="display: none;" class="subscription-check-loading">
          <span class="loading-spinner"></span>
        </div>

        <!-- Button container -->
        <div id="button-wrapper" style="display: none;">
          <button 
            id="account-delete-button" 
            class="delete-button"
            data-customer-id="${customerId}"
            data-shop-id="${shopId}">
            Delete account
          </button>
        </div>
      </div>

      <!-- Delete Confirmation Modal -->
      <div id="deleteConfirmModal" class="modal" style="display: none;">
        <div class="modal-content">
          <div class="modal-header">
            <h2>Are you sure?</h2>
            <button class="close-button" id="closeDeleteModal">&times;</button>
          </div>
          <p id="grace-period-text" class="modal-description"></p>
          <div class="modal-actions">
            <button id="confirmDelete" class="delete-button">Delete account</button>
            <button id="cancelDelete" class="cancel-button">Cancel</button>
          </div>
        </div>
      </div>

      <!-- Cancel Request Confirmation Modal -->
      <div id="cancelRequestModal" class="modal" style="display: none;">
        <div class="modal-content">
          <div class="modal-header">
            <h2>Cancel Account Deletion?</h2>
            <button class="close-button" id="closeCancelModalX">&times;</button>
          </div>
          <p class="modal-description">Are you sure you want to cancel your account deletion request? This action cannot be undone.</p>
          <div class="modal-actions">
            <button id="confirmCancelRequest" class="delete-button">Cancel request</button>
            <button id="closeCancelModal" class="cancel-button">Close</button>
          </div>
        </div>
      </div>
    `;

    // Add the Gadget API script if not already present
    if (!document.querySelector('script[src="https://bayanatify.gadget.app/api/client/web.min.js"]')) {
      const gadgetScript = document.createElement('script');
      gadgetScript.src = 'https://bayanatify.gadget.app/api/client/web.min.js';
      gadgetScript.defer = true;
      document.head.appendChild(gadgetScript);
      
      // Need to wait for script to load
      gadgetScript.onload = initializeAccountDeletion;
    } else {
      // Script already exists, initialize immediately
      initializeAccountDeletion();
    }

    function initializeAccountDeletion() {
      const myExtensionAPI = new Gadget({
        disableSessionStorage: true
      });
      
      // Translation helper function
      function getTranslation(key, replacements = {}) {
        const keys = key.split('.');
        let value = window.theme?.translations?.deleteAccount;
        
        for (const k of keys) {
          value = value?.[k];
        }
    
        // Fallback translations
        const fallbackTranslations = {
          button: "Delete account",
          cancelButton: "Cancel request",
          closeButton: "Close",
          cancelRequestButton: "Cancel request",
          modalTitle: "Are you sure?",
          cancelModalTitle: "Cancel Account Deletion?",
          immediateDeleteWarning: "After confirming, your account will be deleted immediately. All your data will be permanently deleted.",
          gracePeriodWarning: "After confirming, your account will be deleted in {{period}}. You can cancel this request anytime during this period. After this period, all your data will be permanently deleted.",
          cancelConfirmationText: "Are you sure you want to cancel your account deletion request? This action cannot be undone.",
          deletionScheduleText: "Your account is scheduled for deletion on {{date}}",
          successMessages: {
            requestCreated: "Account deletion request created successfully.",
            requestCanceled: "Account deletion request canceled successfully."
          },
          errorMessages: {
            requestCreateFailed: "There was an error processing your request. Please try again later.",
            requestCancelFailed: "There was an error cancelling your request. Please try again later.",
            noCustomer: "No authenticated customer found.",
            sessionTokenError: "Failed to retrieve session token.",
            shopIdError: "Shop ID not found in response",
            missingInfo: "Missing required information"
          },
          timePeriods: {
            daysAndHours: "{{days}} days and {{hours}} hours",
            daysOnly: "{{days}} days",
            hoursOnly: "{{hours}} hours",
            immediately: "immediately"
          }
        };
    
        const result = value || findInObject(fallbackTranslations, key);
        if (typeof result === 'string') {
          // Fix the template string issue with Liquid
          return Object.entries(replacements).reduce(function(str, entry) {
            var search = "{{" + entry[0] + "}}";
            return str.replace(new RegExp(search, 'g'), entry[1]);
          }, result);
        }
        return result;
      }
    
      function findInObject(obj, key) {
        if (obj.hasOwnProperty(key)) return obj[key];
        for (let k in obj) {
          if (typeof obj[k] === 'object') {
            const found = findInObject(obj[k], key);
            if (found !== undefined) return found;
          }
        }
        return undefined;
      }
    
      // Elements
      const buttonContainer = document.getElementById("delete-button-container");
      const buttonWrapper = document.getElementById("button-wrapper");
      const deleteModal = document.getElementById("deleteConfirmModal");
      const cancelRequestModal = document.getElementById("cancelRequestModal");
      const confirmDeleteBtn = document.getElementById("confirmDelete");
      const cancelDeleteBtn = document.getElementById("cancelDelete");
      const confirmCancelRequestBtn = document.getElementById("confirmCancelRequest");
      const closeCancelModalBtn = document.getElementById("closeCancelModalX");
      const closeDeleteModalBtn = document.getElementById("closeDeleteModal");
      const cancelCancelRequestBtn = document.getElementById("closeCancelModal");
      const gracePeriodText = document.getElementById("grace-period-text");
      const deleteButton = document.getElementById("account-delete-button");
    
      // Helper functions
      function formatDate(date) {
        return new Date(date).toLocaleString(window.Shopify.locale || 'en', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZoneName: 'short'
        });
      }
    
      function formatGracePeriodText(days, hours) {
        if (days === 0 && hours === 0) {
          return "immediately";
        }
        if (days === 0) {
          return hours + " hours";
        }
        if (hours === 0) {
          return days + " days";
        }
        return days + " days and " + hours + " hours";
      }
    
      function showModal(modalElement) {
        modalElement.style.display = "flex";
      }
    
      function hideModal(modalElement) {
        modalElement.style.display = "none";
      }
    
      function handleImmediateDeletion() {
        window.location.href = '/account/login';
      }
    
      async function checkSubscriptionStatus(shopId) {
        try {
          const result = await myExtensionAPI.mutate(
            `
            mutation CheckSubscription($shopId: String!) {
              checkSubscriptionStatus(shopId: $shopId) {
                success
                result
              }
            }
            `,
            { shopId: shopId.toString() }
          );
    
          return result?.checkSubscriptionStatus?.result?.hasActiveSubscription ?? false;
        } catch (error) {
          console.error("Error checking subscription status:", error);
          return false;
        }
      }
    
      async function findPendingRequest(shopId, customerId) {
        try {
          const queryResult = await myExtensionAPI.query(
            `
            query CheckGracePeriodRequest($customerId: String!) {
  deleteRequests(filter: { status: { equals: "grace period" }, customerId: { equals: $customerId } }) {
                edges {
                  node {
                    id
                    status
                    deletionDate
                  }
                }
              }
            }
            `,
            { customerId }
          );
    
          const edges = queryResult.deleteRequests.edges;
          return edges.length > 0 ? edges[0].node : null;
        } catch (error) {
          console.error("Error finding pending request:", error);
          return null;
        }
      }
    
      function showPendingDeletion(deletionDate) {
        if (!deleteButton) return;
    
        const customerId = deleteButton.getAttribute('data-customer-id');
        const shopId = deleteButton.getAttribute('data-shop-id');
    
        buttonContainer.innerHTML = `
          <div class="pending-deletion-notice">
            <p class="deletion-message">
              Your account is scheduled for deletion on ${formatDate(deletionDate)}
            </p>
            <button 
              id="cancel-delete-button" 
              class="cancel-request-button"
              data-customer-id="${customerId}"
              data-shop-id="${shopId}">
              Cancel request
            </button>
          </div>
        `;
    
        document.getElementById("cancel-delete-button").addEventListener("click", handleCancelRequest);
      }
    
      async function createDeleteRequest() {
        if (!deleteButton) return;
    
        try {
          const customerId = deleteButton.getAttribute('data-customer-id');
          const shopId = deleteButton.getAttribute('data-shop-id');
    
          if (!customerId || !shopId) {
            throw new Error("Missing required information");
          }
    
          const settingsResult = await myExtensionAPI.query(
            `
            query GetStoreSettingsForShop($shopId: GadgetID!) {
              storeSettingss(filter: { shop: { id: { equals: $shopId }}}) {
                edges {
                  node {
                    id
                    gracePeriodDays
                    gracePeriodHours
                  }
                }
              }
            }
            `,
            { shopId: shopId.toString() }
          );
    
          const settings = settingsResult?.storeSettingss?.edges?.[0]?.node;
          const gracePeriodDays = settings?.gracePeriodDays ?? 0;
          const gracePeriodHours = settings?.gracePeriodHours ?? 24;
    
          if (gracePeriodText) {
            const gracePeriodTimeText = formatGracePeriodText(gracePeriodDays, gracePeriodHours);
            const gracePeriodMessage = gracePeriodDays === 0 && gracePeriodHours === 0
              ? "After confirming, your account will be deleted immediately. All your data will be permanently deleted."
              : "After confirming, your account will be deleted in " + gracePeriodTimeText + ". You can cancel this request anytime during this period. After this period, all your data will be permanently deleted.";
            gracePeriodText.textContent = gracePeriodMessage;
          }
    
          const response = await myExtensionAPI.mutate(
            `
            mutation CreateDeleteRequest($input: CreateDeleteRequestInput!) {
              createDeleteRequest(deleteRequest: $input) {
                deleteRequest {
                  id
                  status
                  deletionDate
                }
              }
            }
            `,
            {
            input: {
  customerId: customerId.toString(),
  storeId: shopId.toString(),
  status: "grace period"
}
            }
          );
    
          const createdRequest = response.createDeleteRequest.deleteRequest;
          hideModal(deleteModal);
    
          if (gracePeriodDays === 0 && gracePeriodHours === 0) {
            handleImmediateDeletion();
          } else {
            showPendingDeletion(createdRequest.deletionDate);
          }
    
        } catch (error) {
          console.error("Error creating delete request:", error);
          alert("There was an error processing your request. Please try again later.");
          hideModal(deleteModal);
        }
      }
    
      async function handleCancelRequest() {
        showModal(cancelRequestModal);
      }
    
      async function executeCancelRequest() {
        const cancelButton = document.getElementById("cancel-delete-button");
        if (!cancelButton) return;
    
        try {
          const customerId = cancelButton.getAttribute('data-customer-id');
          const shopId = cancelButton.getAttribute('data-shop-id');
    
          if (!customerId || !shopId) {
            throw new Error("Missing required information");
          }
    
          const deleteRequest = await findPendingRequest(shopId, customerId);
    
          if (deleteRequest) {
            await myExtensionAPI.mutate(
              `
              mutation UpdateDeleteRequest($id: GadgetID!, $input: UpdateDeleteRequestInput!) {
                updateDeleteRequest(id: $id, deleteRequest: $input) {
                  deleteRequest {
                    id
                    status
                  }
                }
              }
              `,
              {
                id: deleteRequest.id,
                input: {
                  status: "canceled"
                }
              }
            );
    
            hideModal(cancelRequestModal);
            window.location.reload();
          }
    
        } catch (error) {
          console.error("Error cancelling delete request:", error);
          alert("There was an error cancelling your request. Please try again later.");
          hideModal(cancelRequestModal);
        }
      }
    
      async function initialize() {
        if (!buttonContainer || !deleteButton) return;
    
        try {
          const shopId = deleteButton.getAttribute('data-shop-id');
          const customerId = deleteButton.getAttribute('data-customer-id');
    
          if (!shopId || !customerId) return;
    
          const hasActiveSubscription = await checkSubscriptionStatus(shopId);
          if (!hasActiveSubscription) return;
    
          const existingRequest = await findPendingRequest(shopId, customerId);
          if (existingRequest) {
            showPendingDeletion(existingRequest.deletionDate);
          } else {
            buttonWrapper.style.display = "block";
          }
    
          // Set up event listeners
          deleteButton.addEventListener("click", () => showModal(deleteModal));
    
          if (confirmDeleteBtn) {
            confirmDeleteBtn.addEventListener("click", createDeleteRequest);
          }
    
          if (cancelDeleteBtn) {
            cancelDeleteBtn.addEventListener("click", () => hideModal(deleteModal));
          }
    
          if (closeDeleteModalBtn) {
            closeDeleteModalBtn.addEventListener("click", () => hideModal(deleteModal));
          }
    
          if (confirmCancelRequestBtn) {
            confirmCancelRequestBtn.addEventListener("click", executeCancelRequest);
          }
    
          if (closeCancelModalBtn) {
            closeCancelModalBtn.addEventListener("click", () => hideModal(cancelRequestModal));
          }
    
          if (cancelCancelRequestBtn) {
            cancelCancelRequestBtn.addEventListener("click", () => hideModal(cancelRequestModal));
          }
    
          window.addEventListener("click", (event) => {
            if (event.target === deleteModal) hideModal(deleteModal);
            if (event.target === cancelRequestModal) hideModal(cancelRequestModal);
          });
          
          // Initialize grace period text
          if (gracePeriodText) {
            const settingsResult = await myExtensionAPI.query(
              `
              query GetStoreSettingsForShop($shopId: GadgetID!) {
                storeSettingss(filter: { shop: { id: { equals: $shopId }}}) {
                  edges {
                    node {
                      id
                      gracePeriodDays
                      gracePeriodHours
                    }
                  }
                }
              }
              `,
              { shopId: shopId.toString() }
            );
    
            const settings = settingsResult?.storeSettingss?.edges?.[0]?.node;
            const gracePeriodDays = settings?.gracePeriodDays ?? 0;
            const gracePeriodHours = settings?.gracePeriodHours ?? 24;
    
            const gracePeriodTimeText = formatGracePeriodText(gracePeriodDays, gracePeriodHours);
            const gracePeriodMessage = gracePeriodDays === 0 && gracePeriodHours === 0
              ? getTranslation('immediateDeleteWarning')
              : getTranslation('gracePeriodWarning', { period: gracePeriodTimeText });
            gracePeriodText.textContent = gracePeriodMessage;
          }
        } catch (error) {
          console.error("Error during initialization:", error);
        }
      }
    
      // Start initialization
      initialize().catch(console.error);
    }
  });
})();